<template>
  <div class="tscsdetail">
    <detail-title></detail-title>
    <!--视频组件-->
    <div id="tsd-top" class="tsd-top">
      <video-bar v-show="video"></video-bar>
      <!--office组件-->
      <office-bar v-show="office" class="Tsoc"></office-bar>
      <img v-if="showPic" src="../assets/image/poster.png" class="morenPic" />
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="介绍" name="0"></el-tab-pane>
        <el-tab-pane label="推荐课程" name="1"></el-tab-pane>
      </el-tabs>
    </div>
    <div style="padding-top:87vw;padding-bottom:2rem">
      <!-- 介绍 -->
      <div class="d_jump" id="first">
        <div class="tsd-js">
          <p class="offline-title">
            <strong v-html="offList.tscsName">{{offList.tscsName}}</strong>
          </p>
          <p class="tsd-teach">讲师：{{offList.tscsTech}}</p>
          <p class="tsd-others">
            <!-- <span style="color:#FB7C53;">{{offList.tscsPrice}}</span> / 54分钟 / 365人观看 -->
            <span style="color:#FB7C53;">{{offList.tscsPrice}}</span>
            <span v-if="duration">/</span>
            {{duration}}
          </p>
        </div>
        <div class="tsd-line"></div>
        <p class="offline-jj">课程简介</p>
        <div class="offline-detail">
          <p class="offline-intro" v-html="offList.tscsDesc">{{offList.tscsDesc}}</p>
        </div>
      </div>
      <div class="tsd-line"></div>
      <!-- 推荐课程 -->
      <div class="d_jump" id="second">
        <p class="offline-jj">推荐课程</p>
        <div class="listpic">
          <div class="listpic-col" v-for="item in listpic" :key="item.tscsId">
            <el-col :span="10">
              <img :src="item.tscsLogo" alt :onerror="logo" class="listpic-img" />
            </el-col>
            <el-col :span="14" class="listpic-row" style="padding-left:1rem;">
              <div class="listpic-p">{{item.tscsName}}</div>
              <div class="listpic-i">
                <p class="listpic-price" @click="OpenStore()">观看视频请打开APP</p>
              </div>
            </el-col>
          </div>
        </div>
      </div>
    </div>
   <el-row class="Offline-footer">
          <el-col :span="8">
              <p class="off-fire" style="padding-top: 0.5rem;">￥<strong style="font-size:1.8rem;">{{offList.tscsPrice}}</strong></p>
          </el-col>
          <el-col :span="8" class="off-zixun">
              <a v-bind:href="phone"><img src="@/assets/image/tell3.svg" class="Off-tel">咨询</a>
              <span style="color:rgb(230,232,232);">|</span>
          </el-col>
          <el-col :span="8" >
              <button  type="button"  class="Offline-btn2" @click="OpenStore()">前往app观看</button>
          </el-col>
      </el-row>
      <share-wechat></share-wechat>
  </div>
</template>
<script>
import VideoBar from "@/components/VideoBar";
import OfficeBar from "@/components/OfficeBar";
import DetailTitle from "@/components/DetailTitle";
import Axios from "axios";
import $ from "jquery";
import { eventBus } from "@/assets/js/eventBus";
import ShareWechat from "@/components/ShareWechat";
export default {
  data() {
    return {
      activeName: "0",
      list: [],
      offList: [],
      video: false,
      TsocLogo: true,
      office: false,
      logo: 'this.src="' + require("@/assets/image/gg1.jpg") + '"',
      showPic: true,
      type: 1,
      fontcolor: {
        color: "#3486e2"
      },
      duration: "", //视频时长
      page: 1,
      logo: 'this.src="' + require("@/assets/image/gg1.jpg") + '"',
      listpic: [], //数据列表
      listLength: 0,
      choose: "",
      width: "",
      tabtDis: "",
      phone:"tel:400-829-6689",
    };
  },
  components: {
    DetailTitle,
    VideoBar,
    OfficeBar,
    ShareWechat
  },
  mounted() {
    const that = this;
    var id = "";
    var locations = location.href;
    if (locations.indexOf("?") != -1) {
      //判断是否有参数
      if (locations.indexOf("from") != -1) {
        var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
        var strs = str.split("?");
        id = strs[2];
      } else {
        var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
        var strs = str.split("?");
        id = strs[1]; //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
      }
    }
    that.getoffLists(id);
    that.getCourses(id);
    that.width = parseInt(($(window).width() / 100) * 90);
    that.$nextTick(function() {
      window.addEventListener("scroll", that.onScroll);
    });
  },
  methods: {
    handleClick(tab) {
      const that = this;
      if (tab.name == "0") {
        that.activeName = "0";
      } else {
        that.activeName = "1";
      }
      let jump = document.querySelectorAll(".d_jump");
      let total = jump[tab.name].offsetTop - this.width;
      let distance =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 20;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 20;
        smoothUp();
      }
      function smoothDown() {
        if (distance < total) {
          distance += step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      }
      function smoothUp() {
        if (distance > total) {
          distance -= step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothUp, 10);
        } else {
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      }
    },
    onScroll() {
      const that = this;
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (that.tabtDis == "") {
        that.activeName = "0";
      } else if (scrolled < that.tabtDis) {
        that.activeName = "0";
      } else {
        that.activeName = "1";
      }
    },
    // https获取简介数据
    getoffLists(id){
      const that = this;
      that.activeName = "0";
      var search = "";
      Axios.get(
        that.$store.state.APIURLS + "Tscs/findCsByEs?" + id + "&search=" + search
      ).then(function(res) {
        if (res.data.code == 200) {
          if (res.data.data.tscsPrice == "0") {
            res.data.data.tscsPrice = "免费";
          }
          that.offList = res.data.data;
          var shareList = {
              title: res.data.data.tscsName,
              content: res.data.data.tscsDesc,
          };
          eventBus.$emit("shareList", shareList);
          if (that.offList.tscsType == "视频") {
            that.showPic = false;
            that.video = true;
            that.office = false;
            var t = {
              url:that.offList.tscsFile,
              price:that.offList.tscsPrice=='免费'?true:false,
            }
            eventBus.$emit("fileUrl",t);
            eventBus.$on("duration", val => {
              that.duration = Math.round(val / 60) + "分钟";
            });
          } else {
            that.showPic = false;
            that.office = true;
            that.video = false;
            var t = {
              url:that.offList.tscsFile,
              price:that.offList.tscsPrice=='免费'?true:false,
            }
            eventBus.$emit("pptUrl", t);
          }
        }
      });
    },
    // https推荐课堂
    getCourses() {
      const that = this;
      var param = {
        curPage: 1,
        pageSize: 10,
        condition: ""
      };
      that.listpic = [];
      Axios.post(that.$store.state.APIURLS + "Tscs/findRecomByEs", param).then(
        function(res) {
          if (res.data.code == 200) {
            res.data.data.data.forEach(e => {
              if (e.tscsPrice == "0") {
                e.tscsPrice = "免费";
              }
            });
            that.listLength = res.data.data.count;
            // 把请求到的数据添加到列表
            that.listpic = that.listpic.concat(res.data.data.data);
            that.tabtDis = $("#first").height();
          }
        }
      );
    },
    OpenStore() {
      const that = this;
      location.href='http://url.cn/59TtsAP';
    },
  }
};
</script>
